import { Link } from "react-router-dom";
import "../styles/NewsSection.css";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import newsData from "../data/newsData";
import { useNavigate } from "react-router-dom";

// const navigate = useNavigate();

/* header animation */
const headerAnim = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

/* cards stagger container */
const cardContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.18 }
  }
};

/* single card */
const cardAnim = {
  hidden: { opacity: 0, y: 70, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.55, ease: "easeOut" }
  }
};

/* image reveal */
const imageAnim = {
  hidden: { scale: 1.15, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const itemAnim = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};


// DATA
// const newsData = [
//   {
//     date: "05 May 2021",
//     title: "Transform Your IT Career With Fortune Cloud Solutions",
//     image: "/images/news-1.jpg",
//     desc: "This article aims to inspire professionals, particularly students or entry-level candidates, to explore IT careers with confidence, leveraging Fortune Cloud Solutions expertise."
//   },
//   {
//     date: "05 May 2021",
//     title: "Why Fortune Cloud Solutions Is Your Go-To IT Partner",
//     image: "/images/news-2.jpg",
//     desc: "In the fast-evolving world of IT, finding the right partner to meet your talent and project needs is crucial for business success."
//   },
//   {
//     date: "05 May 2021",
//     title: "Tailored IT Solutions For Every Sector",
//     image: "/images/news-3.jpg",
//     desc: "In today’s digital age, Information Technology has become the backbone of industries ranging from healthcare to finance and retail."
//   },

//   {
//     date: "05 May 2021",
//     title: "Success Spotlight: Connecting Talent With Opportunity",
//     image: "/images/news-4.jpg",
//     desc: "At Fortune Cloud Solutions, our mission is clear: to bridge the gap between talent and opportunity through innovative staffing and training solutions."
//   },
//   {
//     date: "05 May 2021",
//     title: "Take The First Step Toward IT Excellence",
//     image: "/images/news-5.jpg",
//     desc: "The IT landscape is evolving faster than ever, with businesses and professionals striving to keep pace with new technologies and challenges."
//   },
//   {
//     date: "05 May 2021",
//     title: "Success Awaits You: Create Your Own Opportunities",
//     image: "/images/news-6.jpg",
//     desc: "Opportunities don’t happen. You create them. Success is not a matter of luck or coincidence; it is the result of dedication and continuous growth."
//   }
// ];

const processData = [
  {
    step: "01",
    title: "UNDERSTAND NEEDS",
    desc: "Collaborate with clients to identify specific requirements and goals."
  },
  {
    step: "02",
    title: "SOURCE TALENT",
    desc: "Use our network to find skilled candidates who match the profile."
  },
  {
    step: "03",
    title: "EVALUATE & TRAIN",
    desc: "Screen candidates and provide tailored training if needed."
  },
  {
    step: "04",
    title: "PLACEMENT & SUPPORT",
    desc: "Ensure seamless onboarding and offer ongoing assistance for long-term success."
  }
];

const Newsection = () => {

  const navigate = useNavigate(); // ✅ Correct place

  // const [isSlider, setIsSlider] = useState(window.innerWidth < 992);

  // useEffect(() => {
  //   const handleResize = () => setIsSlider(window.innerWidth < 992);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  return (
    <>
      {/* ===== PROCESS SECTION ===== */}
      <section className="news-section py-5">
        <div className="container">

          <div className="news-header">
            <div className="header-left">
              <h2 className="testmonial-badge" style={{ display: 'inline-block' }}>
                OUR PROCESS
              </h2>

              <h2 className='text-uppercase'>
                How we work for<br />
                <span className="purple-text">our valued customers</span>
              </h2>

            </div>
            {/* <div className="header-right">
              <Link to="/about">
                <motion.button className="discover-btn" variants={itemAnim}>
                  DISCOVER MORE →
                </motion.button>
              </Link>
            </div> */}
          </div>

          <div className="process-container">
            {processData.map((item, index) => (
              <div className="process-item" key={index}>

                <div className="process-card">
                  <span className="step-number border">{item.step}</span>
                  <h3 className="border-bottom pb-2 fw-bold">{item.title}</h3>

                  <p>{item.desc}</p>
                </div>

                {index !== processData.length - 1 && (
                  <div className="process-arrow">
                    <span><FaArrowRight className="process-arrow-icon fs-6" /></span>
                  </div>
                )}

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== NEWS SECTION ===== */}
      <section className="news-section">
        <div className="news-container">

          <motion.div
            className="news-header"
            variants={headerAnim}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
          >
            <div className="header-left">
              <span className="testmonial-badge">
                NEWS UPDATES
              </span>

              <h2>
                READ OUR LATEST UPDATES & <br />
                <span className="purple-text">BUSINESS TIPS & TRICKS.</span>
              </h2>
            </div>

            <motion.div className="header-right" variants={headerAnim}>
              <Link to="/about">
                <motion.button className="discover-btn" variants={itemAnim}>
                  DISCOVER MORE →
                </motion.button>
              </Link>

            </motion.div>
          </motion.div>


          <div className="news-slider-wrapper position-relative">

            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: ".news-next",
                prevEl: ".news-prev",
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              speed={900}
              spaceBetween={24}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 3 }
              }}
            >
              {newsData.map((item, index) => (
                <SwiperSlide key={index}>
                  <motion.div
                    className="news-card h-100"
                    variants={cardAnim}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-60px" }}
                    onClick={() => navigate(`/resources/${item.slug}`)}
                    style={{ cursor: "pointer" }}
                  >

                    <div className="news-img-wrapper">
                      <motion.img
                        variants={imageAnim}
                        src={item.image}
                        alt={item.title}
                        className="img-fluid"
                      />
                    </div>

                    <div className="news-content">
                      <span className="news-date">{item.date}</span>
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                      <button className="read-more">READ MORE</button>
                    </div>

                  </motion.div>
                </SwiperSlide>

              ))}
            </Swiper>

            {/* arrows */}
            <div className="news-prev nav-arrow">‹</div>
            <div className="news-next nav-arrow">›</div>

          </div>

        </div>
      </section>
    </>
  );
};

export default Newsection;
